// extracted by mini-css-extract-plugin
module.exports = {"monospace":"_2jgeG1eRdhbA9u8vjEGFKt--monospace"};